module.exports = __webpack_public_path__ + "img/notification_icon.0eed76f7.svg";